import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as RegionsActions, Types as RegionsTypes } from 'store/ducks/regions';

function* getRegionRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/regions/${id}`;
    const response = yield call(api.get, url);

    yield put(RegionsActions.getRegionSuccess(response.data));
  } catch (error) {
    yield put(RegionsActions.getRegionFailure());
  }
}

function* getRegionsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `store/v2/regions?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(RegionsActions.getRegionsSuccess(response.data));
  } catch (error) {
    yield put(RegionsActions.getRegionsFailure());
  }
}

function* createRegionRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'store/v2/regions';
    yield call(api.post, url, data);

    yield put(push('/regions'));
    yield call(swal, 'Adicionado', 'Novo região adicionado', 'success');
    yield put(RegionsActions.createRegionSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o região.', 'error');
    yield put(RegionsActions.createRegionFailure());
  }
}

function* updateRegionRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/regions/${id}`;
    yield call(api.put, url, data);

    yield put(push('/regions'));
    yield call(swal, 'Atualizado', 'Região atualizado', 'success');
    yield put(RegionsActions.updateRegionSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar a região.', 'error');
    yield put(RegionsActions.updateRegionFailure());
  }
}

function* deleteRegionRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/regions/${id}`;
    yield call(api.delete, url);

    yield put(push(`/regions?removed=${id}`));
    yield call(swal, 'Deletado', 'Região deletada', 'success');
    yield put(RegionsActions.deleteRegionSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao deletar', 'Não foi possível deletar a região.', 'error');
    yield put(RegionsActions.deleteRegionFailure());
  }
}

function* getRegionPlacesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/places`;
    const response = yield call(api.get, url, { params: { search: query }  });

    yield put(RegionsActions.getRegionPlacesSuccess(response.data));
  } catch (error) {
    yield put(RegionsActions.getRegionPlacesFailure());
  }
}

export default function* sagaRegions() {
  yield takeLatest(RegionsTypes.GET_REQUEST, getRegionRequest);
  yield takeLatest(RegionsTypes.GET_LIST_REQUEST, getRegionsRequest);
  yield takeLatest(RegionsTypes.CREATE_REQUEST, createRegionRequest);
  yield takeLatest(RegionsTypes.UPDATE_REQUEST, updateRegionRequest);
  yield takeLatest(RegionsTypes.DELETE_REQUEST, deleteRegionRequest);
  yield takeLatest(RegionsTypes.GET_PLACES_REQUEST, getRegionPlacesRequest);
}
